import animejs from 'animejs/lib/anime.min.js';
import ServiceLocator from "../../../global/service-locator";
import Form from "./form";

export default class ModalFormGroup {
    constructor(props = {}) {
        this.props = props;
        this.id = this.props.id;

        this.$modal = document.getElementById(`modal-${this.id}`);
        this.$modalTriggers = this.props.$modalTriggers || document.querySelectorAll(`[data-modal-trigger="${this.id}"]`);

        this.forms = this.props.forms || [];

        if (!this.$modal) {
            throw new Error('ModalFormGroup: Modal root element not found!');
        }

        this.$formGroupBody = this.$modal.querySelector('[data-form-group="body"]');
        this.$formItems = this.$modal.querySelectorAll('[data-form-group="item"]');
        this.$nextButtons = this.$modal.querySelectorAll('[data-form-group="next"]');

        this.modalClass = this.props.modalClass;
        this.modalService = ServiceLocator.instance.modalService;
        this.hash = this.props.hash;
        this.urlHashes = this.props.urlHashes;

        this._forms = new Map();
        this._activeItemName = null;
        this._formItems = new Map();

        this._initialized = false;

        this.beforeInit = this.props.beforeInit;
        this.afterInit = this.props.afterInit;
        this.beforeOpen = this.props.beforeOpen;
        this.afterOpen = this.props.afterOpen;
        this.beforeClose = this.props.beforeClose;
        this.afterClose = this.props.afterClose;

        this._init();
    }

    _init() {
        if (!this.forms.length) {
            throw new Error('ModalFormGroup: Form configs are missing!');
        }

        if (!this._initialized) {
            this._initialized = true;
            this._bootstrap();
        }
    }

    _bootstrap() {
        if (typeof this.beforeInit === 'function') {
            this.beforeInit();
        }

        this.modalService.register(this.id, Array.from(this.$modalTriggers), {
            rootClass: this._getModalClassList(),
            hash: this.hash,
            urlHashes: this.urlHashes,
            enabledScroll: Array.from(this.$modal.querySelectorAll('.listbox_opt-list')),
            beforeOpen: this.beforeOpen,
            afterOpen: this.afterOpen,
            beforeClose: this.beforeClose,
            afterClose: this.afterClose
        });

        this.$formItems.forEach(($formItem) => {
            this._formItems.set($formItem.dataset.name, $formItem);

            if ($formItem.dataset.active) {
                this._activeItemName = $formItem.dataset.name;
            }
        });

        this.forms.forEach((form) => this._forms.set(form.id, new Form(form)));

        this._addSubscriptions();

        if (typeof this.afterInit === 'function') {
            this.afterInit();
        }
    }

    _addSubscriptions() {
        this.$nextButtons.forEach(($nextButton) => {
            $nextButton.addEventListener('click', (e) => {
                e.preventDefault();

                const name = $nextButton.dataset.name;

                if (!name) {
                    return;
                }

                this._handleFormChange(name);
            });
        });
    }

    _getModalClassList() {
        let modalClassList = ['-f-form-modal'];

        if (this.modalClass) {
            if (Array.isArray(this.modalClass)) {
                modalClassList.push(...this.modalClass);
            } else if (typeof this.modalClass === 'string') {
                modalClassList.push(...this.modalClass.split(' '));
            }
        }

        return modalClassList;
    }

    _handleFormChange(name) {
        const item = this._formItems.get(name);
        const activeItem = this._formItems.get(this._activeItemName);

        if (!item) {
            throw new Error(`Form: Form item ${name} not found!`);
        }

        if (!activeItem) {
            throw new Error(`Form: Form item ${this._activeItemName} not found!`);
        }

        this._activeItemName = name;

        const activeItemHeight = activeItem.offsetHeight;

        if (!activeItemHeight) {
            activeItem.removeAttribute('data-active');
            item.setAttribute('data-active', true);
            return;
        }

        this.$formGroupBody.style.height = `${activeItemHeight}px`;
        activeItem.removeAttribute('data-active');
        item.style.opacity = 0;
        item.setAttribute('data-active', true);

        animejs({
            targets: this.$formGroupBody,
            height: `${item.offsetHeight}px`,
            duration: 250,
            easing: 'cubicBezier(0, 0.55, 0.45, 1)',
            complete: (anim) => {
                if (anim.completed) {
                    this.$formGroupBody.removeAttribute('style');
                }
            }
        });
        animejs({
            targets: item,
            opacity: 1,
            scale: [0.97, 1],
            duration: 250,
            delay: 250,
            easing: 'cubicBezier(0, 0.55, 0.45, 1)',
            complete: (anim) => {
                if (anim.completed) {
                    item.removeAttribute('style');
                }
            }
        });
    }

    getForm(name) {
        return this._forms.get(name);
    }

    changeView(name) {
        this._handleFormChange(name);
    }

    open() {
        this.modalService.open(this.id);
    }

    close() {
        this.modalService.close();
    }
}